import { useQuery } from "@tanstack/react-query";

import { getInsulins } from "@/api";

export const useInsulins = () => {
  const useInsulinList = () => {
    return useQuery({
      queryKey: ["insulin", "getInsulins"],
      queryFn: () => getInsulins(),
    });
  };

  return { useInsulinList };
};
